import { call, put, takeEvery } from "redux-saga/effects";
import * as types from "../../actions/types/types";
import * as consoleApi from "../../../api/communication/carte";
import addResource from "../../actions/addResource";
import addUIItem from "../../actions/addUIItem";
import * as keys from '../../keys/communication/carte';
import * as statusRequest from '../requestStatus';


export function* watchMobileCarte() {
    yield takeEvery(types.SAVE_CARTE, saveCarte);
}

export function* saveCarte(action) {
    const { queryParams } = action.payload;
    const status = keys.SAVED_CARTE_STATUS;

    try {
        yield put(addUIItem(statusRequest.REQUEST_PENDING, status));

        const result = yield call(
            consoleApi.saveCarte,
            queryParams
        );

        if (!result) {
            throw new Error("Unable to save configuration log");
        }

        yield put(addResource(result, keys.SAVED_CARTE_ID));
        yield put(addUIItem(statusRequest.REQUEST_SUCCEEDED, status));

    } catch (e) {

        yield put(addUIItem(statusRequest.REQUEST_FAILED, status));
    }
}

